import { Col, Title, Row } from '@packages/utils';
import { useNavigate } from 'react-router-dom';
import RemovePeopleOrganization from 'components/Shared/RemovePeopleOrganization';
import PeopleOrganizationTitle from 'components/Shared/PeopleOrganizationTitle';
import { RoutesPaths } from 'routes/Routes.types';
import { TBackButtonState } from 'components/Base/PageWrapper/PageWrapper.types';
import { SCard } from 'pages/private/ELCs/ELCList/ELCItem/ELCItem.styles';

import { TPeopleOrganizationCardProps } from './PeopleOrganizationCard.data';

const PeopleOrganizationCard = ({
  organizationId,
  data,
  allowedActions,
  organizationName,
}: TPeopleOrganizationCardProps) => {
  const navigate = useNavigate();

  const redirectToPeople = () => {
    navigate(`/app/${RoutesPaths.PEOPLE}/${data.userId}`, {
      state: {
        backUrl: window.location.pathname,
        backButtonSuffix: organizationName,
      } as TBackButtonState,
    });
  };
  return (
    <SCard className="mb-3" onClick={redirectToPeople}>
      <Row align="middle" justify="space-between" wrap={false}>
        <Col>
          <Title level={4}>{data.fullName}</Title>
        </Col>
        {allowedActions.canRemove && (
          <Col>
            <RemovePeopleOrganization
              organizationId={organizationId}
              userId={data.userId}
            />
          </Col>
        )}
      </Row>
      <Row>
        <PeopleOrganizationTitle
          data={data}
          userId={data.userId}
          organizationId={organizationId}
        />
      </Row>
    </SCard>
  );
};

export default PeopleOrganizationCard;
